import React, { useEffect } from 'react';
import { Section, SectionTitle } from '@repo/components/containers';
import styles from './Highlights.module.scss';
import { ID } from '@repo/utils/types';
import { useDispatch, useSelector } from 'react-redux';
import { fetchHighlights } from '@repo/redux/actions/highlights';
import ActivityListItem from '@views/Activity/ActivityListItem';
import { selectHighlights } from '@repo/redux/reducers/data/highlights';
import Content from './HighlightItem/Content';
import Subheader from './HighlightItem/Subheader';

interface HighlightsProps {
  contactID: ID;
}

export function HighlightsList({ highlights }) {
  return (
    highlights.length > 0 && (
      <Section>
        <SectionTitle underline>Highlights</SectionTitle>
        {highlights.map((item, i) => (
          <div key={i} className={styles.item}>
            <ActivityListItem
              item={item}
              selected={false}
              noContactActions
              noDismissal
              onlyRelativeDate
            />
          </div>
        ))}
      </Section>
    )
  );
}

export function SharedContactHighlightsList({ highlights }) {
  return (
    highlights.length > 0 && (
      <Section>
        <SectionTitle underline>Highlights</SectionTitle>
        {highlights.map((item, i) => (
          <div key={i} className={styles.sharedContactItem}>
            <Content item={item} />
            <Subheader item={item} />
          </div>
        ))}
      </Section>
    )
  );
}

export default function Highlights({ contactID }: HighlightsProps) {
  const dispatch = useDispatch();
  const highlights = useSelector(selectHighlights(contactID));

  useEffect(() => {
    dispatch(fetchHighlights(contactID));
  }, []);

  return <HighlightsList highlights={highlights} />;
}
